import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
  useEffect
} from 'react';
import Script from 'next/script';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';
import { usePublicRuntimeConfig } from '../../hooks/usePublicRuntimeConfig';

export interface ViralLoopsConfig {
  setLoadVLScript?: Dispatch<SetStateAction<boolean>>;
  setIsReturningUser?: Dispatch<SetStateAction<boolean>>;
  isReturningUser?: boolean;
  VL?: any;
}

export interface ViralLoopsProvider {
  children?: ReactNode | ReactNode[];
}

export const ViralLoopsContext = createContext<ViralLoopsConfig>({});

export const useViralLoopsScript = () => useContext(ViralLoopsContext);

export function ViralLoopsDataProvider({ children }: ViralLoopsProvider) {
  const [loadVLScript, setLoadVLScript] = useState(false);
  const [isReturningUser, setIsReturningUser] = useState(false);
  const [VL, setVL] = useState(
    (typeof window !== 'undefined' && (window as any)).VL || {}
  );

  const { vlCampaignId } = usePublicRuntimeConfig();

  useEffect(() => {
    window.addEventListener(
      'vl_ready',
      () => {
        setVL((window as any).VL);
        // Fire segment event
        trackWithFingerprint('Loaded a Screen', {
          name: 'Credit Waitlist Viewed'
        });
      },
      false
    );
  }, []);

  useEffect(() => {
    if (isReturningUser) {
      VL?.openModal?.();
    }
  }, [isReturningUser]);

  return (
    <ViralLoopsContext.Provider
      value={{
        setLoadVLScript,
        isReturningUser,
        setIsReturningUser,
        VL
      }}
    >
      {children}
      {loadVLScript && (
        <Script id="viral-loops">{`!function(a,b,c,d,t){var e,f=a.getElementsByTagName("head")[0];if(!a.getElementById(c)){if(e=a.createElement(b),e.id=c,e.setAttribute("data-vrlps-ucid",d),e.setAttribute("data-vrlps-version","2"), e.setAttribute("data-vrlps-template", t),e.src="https://app.viral-loops.com/popup_assets/js/vl_load_v2.min.js",window.ub){jQuery=null,$=null;var g=a.createElement(b);g.src="https://code.jquery.com/jquery-2.2.4.min.js",f.appendChild(g)}f.appendChild(e);var h=a.createElement("link");h.rel="stylesheet",h.type="text/css",h.href="https://app.viral-loops.com/static/vl-loader.css",f.appendChild(h);var i=a.createElement("div");i.id="vl-overlay",i.style.display="none";var j=a.createElement("div");j.id="vl-loader",i.appendChild(j),a.addEventListener("DOMContentLoaded",function(b){a.body.appendChild(i);for(var c=a.getElementsByClassName("vrlps-trigger"),d=0;d<c.length;d++)c[d].removeAttribute("href"),c[d].onclick=function(){a.getElementById("vl-overlay").style.display="block"};var e=a.querySelectorAll("[data-vl-widget='popupTrigger']");[].forEach.call(e,function(b){var c=a.createElement("div");c.className="vl-embedded-cta-loader",b.appendChild(c)})})}}(document,"script","vrlps-js","${vlCampaignId}","ranking");`}</Script>
      )}
    </ViralLoopsContext.Provider>
  );
}

export const useViralLoopsContext = () => useContext(ViralLoopsContext);
